import React from "react";
import Icon from "@ant-design/icons";
import styled from "styled-components";

function CalendarSvg({ height = "1em", width = "1em", fill = "#1890ff" }) {
  return (
    <svg
      height={height}
      viewBox="0 0 512 512"
      width={width}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m497 30h-61v-15c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v15h-135v-15c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v15h-135v-15c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v15h-61c-8.285156 0-15 6.714844-15 15v452c0 8.285156 6.714844 15 15 15h482c8.285156 0 15-6.714844 15-15v-452c0-8.285156-6.714844-15-15-15zm-421 30v35.035156c-8.957031 5.195313-15 14.886719-15 25.964844 0 16.542969 13.457031 30 30 30s30-13.457031 30-30c0-11.078125-6.042969-20.769531-15-25.964844v-35.035156h135v35.035156c-8.957031 5.195313-15 14.886719-15 25.964844 0 16.542969 13.457031 30 30 30s30-13.457031 30-30c0-11.078125-6.042969-20.769531-15-25.964844v-35.035156h135v35.035156c-8.957031 5.195313-15 14.886719-15 25.964844 0 16.542969 13.457031 30 30 30s30-13.457031 30-30c0-11.078125-6.042969-20.769531-15-25.964844v-35.035156h46v121h-452v-121zm-46 422v-271h452v271zm0 0" />

      <path d="m256 331c-8.269531 0-15-6.730469-15-15s6.730469-15 15-15c5.339844 0 10.320312 2.878906 13.003906 7.511719 4.144532 7.167969 13.320313 9.621093 20.492188 5.472656s9.621094-13.324219 5.472656-20.496094c-5.425781-9.382812-14.023438-16.351562-23.96875-19.882812v-17.003907c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v16.976563c-17.460938 6.195313-30 22.867187-30 42.421875 0 24.8125 20.1875 45 45 45 8.269531 0 15 6.730469 15 15s-6.730469 15-15 15c-5.339844 0-10.320312-2.878906-13.003906-7.511719-4.144532-7.167969-13.320313-9.621093-20.492188-5.472656s-9.621094 13.324219-5.472656 20.496094c5.425781 9.382812 14.023438 16.351562 23.96875 19.882812v16.40625c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-16.378906c17.460938-6.195313 30-22.867187 30-42.421875 0-24.8125-20.1875-45-45-45zm0 0" />
    </svg>
  );
}

const Wrapper = styled(Icon)`
  svg {
    :hover {
      transition: 1s;
      fill: #05294a;
    }
  }
`;

export function CalendarIcon(props) {
  return <Wrapper component={() => <CalendarSvg {...props} />} {...props} />;
}
